import { Field, FieldProps } from 'formik';
import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { CancelledRequest, HttpExecutorConfig } from '../../Shared/HttpRequestExecutor';
import { Nullable } from '../../Shared/Types';
import { SingleSelectProps, StyledSelect } from '../StyledSelect';
import { getErrorText } from './getErrorText';

export class FormikStyledSelectAsync<SingleSelectType = any> extends React.Component<
    SingleSelectProps<SingleSelectType> & {
        name: string;
        useCache?: boolean;
        emptyValue?: any;
        isClearable: boolean;
        fetch(config: HttpExecutorConfig, query: string, limit: number): Promise<SingleSelectType[] | CancelledRequest>;
        selectRef?(inputElement: Nullable<AsyncSelect<SingleSelectType> | Select<SingleSelectType>>): void;
        onFocus?(): void;
        onClick?(): void;
        testId: string;
        hideOptionsWhenReloading?: boolean;
    }
> {
    public render() {
        return (
            <Field name={this.props.name} readOnly={this.props.readOnly}>
                {this.renderSingleSelectField}
            </Field>
        );
    }

    private renderSingleSelectField = ({ field, form }: FieldProps) => {
        const errorText = getErrorText(form, field.name);

        const { onSelection, onClear, warningText, emptyValue, fetch, testId, ...otherProps } = this.props;

        const handleSelection = (value: Nullable<SingleSelectType> | SingleSelectType[]) => {
            const newValue = value ? value : emptyValue !== undefined ? emptyValue : null;

            if (onSelection) onSelection(newValue);

            form.setFieldValue(field.name, newValue);
            form.setFieldTouched(field.name, true, false);
        };

        const handleClear = () => {
            if (onClear) onClear();

            form.setFieldValue(field.name, emptyValue !== undefined ? emptyValue : null);
            form.setFieldTouched(field.name, true, false);
        };

        const handleItemError = (item: SingleSelectType) => {
            const items: SingleSelectType[] = field.value;
            const indexOfItem = items.findIndex(it => this.props.itemToMenuKey(it) === this.props.itemToMenuKey(item));

            if (indexOfItem >= 0) {
                return !!getErrorText(form, `${field.name}[${indexOfItem}]`, true);
            }

            return false;
        };

        return (
            <StyledSelect<SingleSelectType>
                {...otherProps}
                fetch={fetch}
                value={field.value}
                onSelection={handleSelection}
                onClear={handleClear}
                errorText={errorText}
                warningText={warningText}
                testId={testId}
                itemHasError={handleItemError}
                hideOptionsWhenReloading={this.props.hideOptionsWhenReloading}
            />
        );
    };
}
